var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "gg-card",
        {
          staticClass: "mb-4"
        },
        [
          _c("gg-card-header", [_vm._v(" Affiliate Banner Instructions ")]),
          _c(
            "gg-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "pt-2"
                        },
                        [
                          _vm._v(
                            " Below are the available banners that you as an affiliate are free to use grouped by our most popular products & services. "
                          )
                        ]
                      ),
                      _c("b", [_vm._v("Banner Sizes")]),
                      _c("p", [
                        _vm._v(
                          ' The banner previews are slightly resized for ease of view purposes. You will be able to view the full size banner by clicking on "View Full Size". '
                        )
                      ]),
                      _c("b", [_vm._v("Affiliate Code")]),
                      _c("p", [
                        _vm._v(
                          " To link to us with your affiliate code, simply copy and paste the entire HTML code on to your website. Your affiliate ID is already embedded into the code. "
                        )
                      ]),
                      _c("b", [_vm._v("Campaign Codes")]),
                      _c(
                        "p",
                        {
                          staticClass: "mb-0"
                        },
                        [
                          _vm._v(
                            " For those affiliates who have created campaign codes for detailed tracking, you can select the campaign code you wish to generate the HTML code for. You will then be able to simply copy/paste the code to your website. "
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "gg-card",
        [
          _c("gg-card-header", [_vm._v(" Banners ")]),
          _c(
            "gg-card-text",
            {
              staticClass: "text-center"
            },
            [
              _c(
                "div",
                {
                  staticClass: "d-inline-flex"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "text-left"
                    },
                    [
                      _c("gg-select", {
                        attrs: {
                          outlined: "",
                          items: _vm.tabTitles,
                          "item-value": "id",
                          label: "Select Banner Type"
                        },
                        model: {
                          value: _vm.tab,
                          callback: function callback($$v) {
                            _vm.tab = $$v
                          },
                          expression: "tab"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "v-tabs",
                {
                  model: {
                    value: _vm.tab,
                    callback: function callback($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                _vm._l(_vm.tabItems, function(items, i) {
                  return _c(
                    "v-tab-item",
                    {
                      key: "item-".concat(i)
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "px-4 pt-4",
                          attrs: {
                            flat: ""
                          }
                        },
                        [
                          _vm.profile
                            ? _c(
                                "v-card-text",
                                _vm._l(items, function(banner, j) {
                                  return _c("banner", {
                                    key: "banner-".concat(j),
                                    attrs: {
                                      affiliate: _vm.profile.username,
                                      campaigns: _vm.campaignCodes,
                                      "image-url": banner.image,
                                      size: banner.size
                                    }
                                  })
                                }),
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }